import React, {Suspense, lazy} from 'react';
import {HashRouter, Route, Switch, Redirect} from 'react-router-dom';

import Main from './Main';
import Theme from './assets/Theme';

import {Box} from "@mui/material";

const Complaints = lazy(() => import('./pages/Complaints'));
const HelpForm = lazy(() => import('./pages/HelpForm'));

function App() {
  return (
    <Box mb={5}>
      <HashRouter hashType={'hashbang'}>
        <Main>
          <Theme>
            <Suspense fallback={<div>Loading...</div>}>
              <Switch>
                {/*<Route exact path="/complaints/:complaints?" component={Complaints} />*/}
                <Route exact path="/" component={HelpForm} />
                <Route path="/">
                  <Redirect to="/"/>
                </Route>
              </Switch>
            </Suspense>
          </Theme>
        </Main>
      </HashRouter>
    </Box>
  );
}

export default App;
